import React, { useState,useEffect } from 'react'
import './design.css';
import { SurveyQuestionTypes } from './Helpers/QuestionsModel';
import Question from './Question';
import { useDrop } from 'react-dnd';
export const QuestionsList = ({ 
  questions, 
  selected, 
  currentPage, 
  onClick, 
  clone,
  moveQuestion,
  hideQuestion,
  ...props 
}) => {
  //console.log("QuestionsList rendered with questions:", questions);
  const [, drop] = useDrop({
    accept: 'question',
    drop(item, monitor) {
      if (!monitor.didDrop() && item.pageIndex !== currentPage) {
        moveQuestion(
          item.pageIndex,
          item.index,
          currentPage,
          questions.length
        );
      }
    },
    hover(item, monitor) {
      if (questions.length === 0) {
        moveQuestion(
          item.pageIndex,
          item.index,
          currentPage,
          0
        );
      }
    }
  });

  return (
    <div 
      ref={drop} 
      className="question-list"
      style={{
        minHeight: questions.length === 0 ? '10px' : 'auto',
        padding: questions.length === 0 ? '2px 0' : '0'
      }}
    >
      {questions.length > 0 ? (
        questions.map((question, index) => {
          const isSelected = selected.pageIndex === currentPage && 
                           selected.questionIndex === index;
          
          const className = [
            'question',
            isSelected ? 'selected' : '',
            question.errorStatus ? 'error' : ''
          ].filter(Boolean).join(' ');

          return (
            <Question
              key={`page-${currentPage}-q-${index}`} // Unique key per page
              className={className}
              index={index}
              currentPage={currentPage}
              onClick={onClick}
              question={question}
              clone={clone}
              moveQuestion={moveQuestion}
              hideQuestion={hideQuestion}
              {...props}
            />
          );
        })
      ) : (
        <div className="empty-drop-target" >
         Please add or drop question
        </div>
      )}
    </div>
  );
};
export const QuestionTypeList = (props) => {

  const { onClick, selected } = props;
  // const { questionnaireDetails } = useSelector((state) => { return state.questionnaire });
  const [displayQuestions, setDisplayQuestions] = useState([...SurveyQuestionTypes]);

  // useEffect(() => {
  //   const { questionnaireTypeId } = questionnaireDetails;
  //   if (questionnaireTypeId === 3) {
  //     setDisplayQuestions([...demographyQuestions]);
  //   }
  //   return () => { }
  // }, [questionnaireDetails]);

  return (<div className="row" style={{ 'justifyContent': 'center' }}>
    <div className="row question-type-list" >
      {displayQuestions.map((ques) => {
         const style = ques.id === selected ? "question-type selected" : "question-type";
        // const style = "question-type";
        return <div key={ques.id} className={style}
          onClick={() => onClick(ques)}
        >
          <div style={{ marginRight: 10 }}><i className={ques.icon + " icon"} /></div>
          <div>{ques.label}</div>
        </div>
      })}
      {/* Questions Type LIsts */}
    </div>
  </div>)
}
